export const ENDPOINT_REGIONS_FIND_ALL = '/api/regions/list';
export const ENDPOINT_REGIONS_FIND_ONE = '/api/regions/get-one';
export const ENDPOINT_REGIONS_CREATE_ONE = '/api/regions/create';
export const ENDPOINT_REGIONS_DELETE_ONE = '/api/regions/delete';
export const ENDPOINT_REGIONS_UPDATE_ONE = '/api/regions/update';
